import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { set } from "date-fns";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function MsgObjetoCreado(props) {
  const history = useHistory();
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    props.setCreado(false);
    if (props.drawer) {
      props.drawer(false);
    }
    if (props.stepper) {
      props.stepper(false);
    }

    if (props.datosTurno) {
      props.setNroDoc(props.datosTurno.nroDoc)
      props.setNroTurno(props.datosTurno.nroTurno)
      props.setMostrarDetalle(true)
    } 
    // if(!props.turnoInterno  && props.datosTurno) {
    //   history.push({
    //     pathname: "/detalleTurno",
    //     state: {
    //       nroTurno: props.datosTurno.nroTurno,
    //       nroDoc: props.datosTurno.nroDoc,
    //     },
    //   });
    // }

    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {"Carga Completada"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {props.msg}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose()} color="primary">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default MsgObjetoCreado;
